import React from "react";
import { SimpleGrid, Stack, Text } from "@mantine/core";
import moment from "moment";
import { FormSectionCard } from "../../layout/page";
import { getEntityLabel } from "../../data/mcaEntities";
import { useFormatter } from "../../hooks/useFomatter";

const OverviewItem = ({ label, value }) => (
  <Stack spacing={2}>
    <Text size="xs" color="dimmed" transform="uppercase" weight={600}>
      {label}
    </Text>
    <Text size="sm">{value ?? "—"}</Text>
  </Stack>
);

const McaOverview = ({ request }) => {
  const [formatter] = useFormatter();
  const makerName =
    formatter.friendlyName(request.maker) ||
    request.maker?.name ||
    request.maker?.cname ||
    "—";

  return (
    <FormSectionCard title="Overview">
      <SimpleGrid cols={2} breakpoints={[{ maxWidth: "sm", cols: 1 }]} spacing="lg">
        <OverviewItem
          label="Entity"
          value={getEntityLabel(request.targetEntity)}
        />
        <OverviewItem label="Maker" value={makerName} />
        <OverviewItem label="Action" value={request.action} />
        <OverviewItem
          label="Submitted"
          value={
            request.createdAt
              ? moment(request.createdAt).format("YYYY-MM-DD HH:mm")
              : "—"
          }
        />
        <OverviewItem
          label="Process"
          value={request.process?.name ?? request.process?.code ?? "—"}
        />
        <OverviewItem
          label="Rounds · Rejections"
          value={`${request.submitCount ?? 1} · ${request.rejectCount ?? 0}`}
        />
        {request.targetEntityCode && (
          <OverviewItem label="Target code" value={request.targetEntityCode} />
        )}
        {request.completedAt && (
          <OverviewItem
            label="Completed at"
            value={moment(request.completedAt).format("YYYY-MM-DD HH:mm")}
          />
        )}
      </SimpleGrid>
    </FormSectionCard>
  );
};

export default McaOverview;
